import { setTerms } from './helpers';

export const setOfferSeller = setTerms('offer_seller_type');
